/* eslint-disable no-unused-expressions */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React from "react";

import { Button } from "reactstrap";

import styled from "styled-components";

import { LabSelect } from "../../course/select";
import { convertToTitleCase } from "../../RelevosInfoGeneral/utils";
import { CustomLabel } from "../../../ui/labels";
import { ButtonPrimary } from "../../../ui/buttons";
import { GridGroup } from "../styles";
import { InputText, InputCheckboxContainer } from "../../../ui/inputs";

export const CheckboxContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const CustomTr = styled.tr`
  display: flex;
  align-items: center;
  justify-content: space-around;
  height: 25px;
`;

export const TemplateHeader = styled.h3`
  font-family: "Nunito";
  font-size: 20px;
  font-weight: 500;
  margin-top: 20px;
  border-bottom: 1px solid #293134;
  width: 100%;
  margin-bottom: 30px;
`;

const idiomas = ["ingles", "aleman", "frances", "portugues", "chino"];

const CandidateProfile = ({
  toggle,
  formik,
  handleReactSelectChange,
  estudiosOptions,
  estudiosValue,
  nivelDeEstudiosOptions,
  nivelDeEstudiosValue,
  areaDeExperienciaOptions,
  areasDeExperienciaValue,
  isLoadingCategoies,
}) => {
  return (
    <>
      <div style={{ width: "90%", margin: "0 auto" }}>
        <div style={{ display: "flex", justifyContent: "center", flexDirection: "column" }}>
          <GridGroup className="mb-1">
            <div className="mb-1">
              <CustomLabel>Estudios académicos</CustomLabel>
              <LabSelect
                id="estudios"
                name="estudios"
                className="w-100"
                onChange={handleReactSelectChange}
                value={estudiosValue}
                placeholder="Seleccionar"
                isClearable
                options={estudiosOptions}
              />
            </div>
            <div className="mb-1">
              <CustomLabel>Nivel de estudios</CustomLabel>
              <LabSelect
                id="nivelDeEstudios"
                name="nivelDeEstudios"
                className="w-100"
                onChange={handleReactSelectChange}
                value={nivelDeEstudiosValue}
                placeholder="Seleccionar"
                isClearable
                options={nivelDeEstudiosOptions}
                isDisabled={!estudiosValue}
              />
            </div>
          </GridGroup>
          <div className="mb-1">
            <CustomLabel>Título</CustomLabel>
            <InputText className="w-100" type="text" id="titulo" name="titulo" onBlur={formik.handleBlur} onChange={formik.handleChange} value={formik.values.titulo} />
          </div>
          <GridGroup className="mb-1">
            <div className="mb-1">
              <CustomLabel>Area de experiencia laboral</CustomLabel>
              <LabSelect
                id="areaDeExperiencia"
                name="areaDeExperiencia"
                className="w-100"
                onChange={handleReactSelectChange}
                value={areasDeExperienciaValue}
                placeholder="Seleccionar"
                isClearable
                isLoading={formik.isSubmitting || isLoadingCategoies}
                isDisabled={isLoadingCategoies || formik.isSubmitting}
                options={areaDeExperienciaOptions}
              />
            </div>
          </GridGroup>

          {/* IDIOMAS----------------- */}
          <div className="w-100 my-3">
            <TemplateHeader> Idiomas </TemplateHeader>
            <table border="0" style={{ width: "100%", margin: "20px auto" }}>
              <GridGroup>
                {idiomas.map((item) => (
                  <CustomTr key={item}>
                    <td style={{ width: "20%" }}>
                      <CustomLabel> {convertToTitleCase(item)} </CustomLabel>
                    </td>
                    <td style={{ display: "flex", width: "80%", justifyContent: "space-around" }}>
                      <CheckboxContainer>
                        <CustomLabel htmlFor={`${item}Basico`}> Básico </CustomLabel>
                        <InputCheckboxContainer customBorder="1px solid #293134">
                          <div className="checkbox-wrapper-19">
                            <input
                              type="checkbox"
                              id={`${item}Basico`}
                              name={item}
                              disabled={formik.isSubmitting}
                              onChange={() => formik.setFieldValue(item, formik.values[item] === "basico" ? "" : "basico")}
                              onBlur={formik.handleBlur}
                              checked={formik.values[item] === "basico"}
                              value="basico"
                            />
                            <label htmlFor={`${item}Basico`} className="check-box" />
                          </div>
                        </InputCheckboxContainer>
                      </CheckboxContainer>

                      <CheckboxContainer>
                        <CustomLabel htmlFor={`${item}Intermedio`}> Intermedio </CustomLabel>
                        <InputCheckboxContainer customBorder="1px solid #293134">
                          <div className="checkbox-wrapper-19">
                            <input
                              type="checkbox"
                              id={`${item}Intermedio`}
                              name={item}
                              disabled={formik.isSubmitting}
                              onChange={() => formik.setFieldValue(item, formik.values[item] === "intermedio" ? "" : "intermedio")}
                              onBlur={formik.handleBlur}
                              checked={formik.values[item] === "intermedio"}
                              value="intermedio"
                            />
                            <label htmlFor={`${item}Intermedio`} className="check-box" />
                          </div>
                        </InputCheckboxContainer>
                      </CheckboxContainer>

                      <CheckboxContainer>
                        <CustomLabel htmlFor={`${item}Avanzado`}> Avanzado </CustomLabel>
                        <InputCheckboxContainer customBorder="1px solid #293134">
                          <div className="checkbox-wrapper-19">
                            <input
                              type="checkbox"
                              id={`${item}Avanzado`}
                              name={item}
                              disabled={formik.isSubmitting}
                              onChange={() => formik.setFieldValue(item, formik.values[item] === "avanzado" ? "" : "avanzado")}
                              onBlur={formik.handleBlur}
                              checked={formik.values[item] === "avanzado"}
                              value="avanzado"
                            />
                            <label htmlFor={`${item}Avanzado`} className="check-box" />
                          </div>
                        </InputCheckboxContainer>
                      </CheckboxContainer>

                      <CheckboxContainer>
                        <CustomLabel htmlFor={`${item}Bilingue`}> Bilingüe </CustomLabel>
                        <InputCheckboxContainer customBorder="1px solid #293134">
                          <div className="checkbox-wrapper-19">
                            <input
                              type="checkbox"
                              id={`${item}Bilingue`}
                              name={item}
                              disabled={formik.isSubmitting}
                              onChange={() => formik.setFieldValue(item, formik.values[item] === "bilingue" ? "" : "bilingue")}
                              onBlur={formik.handleBlur}
                              checked={formik.values[item] === "bilingue"}
                              value="bilingue"
                            />
                            <label htmlFor={`${item}Bilingue`} className="check-box" />
                          </div>
                        </InputCheckboxContainer>
                      </CheckboxContainer>
                    </td>
                  </CustomTr>
                ))}
              </GridGroup>
            </table>
            {/* <div className="mb-1">
              <CustomLabel htmlFor="otrosIdiomas"> Otros </CustomLabel>
              <InputText
                type="text"
                id="otrosIdiomas"
                disabled={formik.isSubmitting}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.otrosIdiomas}
                maxLength={40}
              />
            </div> */}
          </div>
        </div>

        <div className="mt-3 mb-0 d-flex justify-content-end" style={{ paddingTop: "10px", borderTop: "1px solid #CCCCCC" }}>
          <Button color="btn-secondary mr-2" onClick={toggle}>
            Cancelar
          </Button>
          <ButtonPrimary isLoading={formik.isSubmitting} disabled={formik.isSubmitting} type="button" onClick={formik.handleSubmit}>
            Guardar
          </ButtonPrimary>
        </div>
      </div>
    </>
  );
};

export default CandidateProfile;
